export const MicrophoneIcon = (): JSX.Element => (
   <svg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='38' height='38' rx='19' fill='white' />
      <path
         d='M18.5254 24.4118C17.7486 24.4118 17.0883 24.1373 16.5445 23.5883C16.0007 23.0393 15.7288 22.3726 15.7288 21.5883V15.9413C15.7288 15.157 16.0007 14.4904 16.5445 13.9413C17.0883 13.3923 17.7486 13.1178 18.5254 13.1178C19.3023 13.1178 19.9626 13.3923 20.5064 13.9413C21.0501 14.4904 21.322 15.157 21.322 15.9413V21.5883C21.322 22.3726 21.0501 23.0393 20.5064 23.5883C19.9626 24.1373 19.3023 24.4118 18.5254 24.4118ZM17.5932 31V28.1059C15.9774 27.8863 14.6412 27.1569 13.5847 25.9177C12.5282 24.6785 12 23.2354 12 21.5883H13.8644C13.8644 22.8903 14.3189 24.0001 15.2278 24.9177C16.1367 25.8353 17.2359 26.2942 18.5254 26.2942C19.815 26.2942 20.9142 25.8353 21.8231 24.9177C22.732 24.0001 23.1864 22.8903 23.1864 21.5883H25.0508C25.0508 23.2354 24.5226 24.6785 23.4661 25.9177C22.4096 27.1569 21.0734 27.8863 19.4576 28.1059V31H17.5932Z'
         fill='url(#paint0_linear_871_40719)'
      />
      <path
         d='M22.9958 7C22.0437 9.30876 21.2783 10.0816 18.9915 11.0427C21.2783 12.0039 22.0437 12.7767 22.9958 15.0855C23.9478 12.7767 24.7132 12.0039 27 11.0427C24.7132 10.0816 23.9478 9.30876 22.9958 7Z'
         fill='url(#paint1_linear_871_40719)'
      />
      <defs>
         <linearGradient id='paint0_linear_871_40719' x1='13.5' y1='7' x2='25.5' y2='31' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#8946D4' />
            <stop offset='1' stopColor='#2879BD' />
         </linearGradient>
         <linearGradient id='paint1_linear_871_40719' x1='13.5' y1='7' x2='25.5' y2='31' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#8946D4' />
            <stop offset='1' stopColor='#2879BD' />
         </linearGradient>
      </defs>
   </svg>
);
